const ca = {
  translation: {
    welcome: 'Menú Escolar',
    dashboard: 'Tauler',
    logout: 'Tancar Sessió',
    adminDashboard: 'Tauler d\'Administració',
    viewPublicSite: 'Veure Lloc Públic',
    allSchools: 'Totes les Escoles',
    // Landing page translations
    landing: {
      hero: {
        title: 'Simplifiqueu la Gestió del Menú Escolar',
        subtitle: 'Creeu, traduïu i compartiu els vostres menús escolars en múltiples idiomes amb una plataforma fàcil d\'utilitzar.',
        getStarted: 'Comenceu Gratis',
        goToDashboard: 'Anar al Tauler',
        learnMore: 'Saber-ne Més'
      },
      features: {
        title: 'Tot el que Necessiteu per a la Gestió de Menús Escolars',
        menuCreation: {
          title: 'Creació de Menús',
          description: 'Creeu menús setmanals o mensuals amb el nostre editor intuïtiu. Afegiu plats, tipus de plat i informació sobre dietes especials.'
        },
        translation: {
          title: 'Suport Multilingüe',
          description: 'Traduïu els vostres menús a múltiples idiomes. Perfecte per a escoles internacionals i comunitats diverses.'
        },
        sharing: {
          title: 'Subdomini Personalitzat',
          description: 'Compartiu els vostres menús amb un subdomini personalitzat (lavostraescola.menusescolars.xyz) per a un fàcil accés per part de pares i estudiants.'
        },
        communityAccess: {
          title: 'Accés Fàcil per a la Comunitat',
          description: 'Proporcioneu als pares i estudiants un accés senzill per veure els últims menús des de qualsevol dispositiu mitjançant una pàgina pública dedicada.'
        }
      },
      cta: {
        title: 'Preparat per simplificar la gestió del menú escolar?',
        subtitle: 'Creeu un compte o inicieu sessió per començar a gestionar els menús de la vostra escola avui mateix.',
      },
      footer: {
        about: 'Sobre Nosaltres',
        aboutText: 'Menús Escolars és una plataforma dedicada a facilitar la planificació i compartició d\'àpats escolars per a escoles d\'arreu del món.',
        links: 'Enllaços Ràpids',
        features: 'Característiques',
        pricing: 'Preus',
        faq: 'Preguntes Freqüents',
        legal: 'Legal',
        privacy: 'Política de Privacitat',
        terms: 'Termes del Servei',
        contact: 'Contacteu-nos',
        email: 'Correu: info@menusescolars.xyz',
        rights: 'Tots els drets reservats.'
      },
      modal: {
        title: 'Gràcies per subscriure-us!',
        message: "Us mantindrem informats sobre les darreres característiques i notícies.",
        close: 'Tancar'
      },
      nav: {
        pricing: 'Preus'
      }
    },
    pricing: {
      title: 'Preus',
      earlyAccessDescription: 'Felicitats, sou una de les primeres persones a descobrir schoolmenus.xyz! Encara estem en desenvolupament, el que significa que els usuaris poden trobar alguns errors o problemes de rendiment de tant en tant (esperem que tots siguin menors).',
      freeUntilStable: 'Com a agraïment per la vostra paciència, schoolmenus.xyz serà gratuït fins que tinguem llesta una primera versió estable. En aquest moment, s\'introduiran plans de preus, però els usuaris existents seran recompensats amb una subscripció gratuïta d\'un any perquè pugueu continuar utilitzant schoolmenus.xyz almenys durant la resta del curs escolar sense haver de preocupar-vos per començar a pagar.'
    },
    common: {
      loading: 'Carregant...',
      save: 'Desar',
      saving: 'Desant...',
      cancel: 'Cancel·lar',
      edit: 'Editar',
      delete: 'Eliminar',
      create: 'Crear',
      search: 'Cercar',
      filter: 'Filtrar',
      noData: 'No hi ha dades disponibles',
      error: 'Error',
      retry: 'Tornar a provar',
      new: 'Nou',
      confirm: 'Confirma',
      close: 'Tancar',
      add: 'Afegeix',
      remove: 'Elimina',
      upload: 'Puja',
      download: 'Descarrega',
      yes: 'Sí',
      no: 'No',
      back: 'Torna',
      next: 'Següent',
      all: 'Tots',
      none: 'Cap',
      welcome: 'Benvingut/da',
      logout: 'Tanca sessió',
      login: 'Inicia sessió',
      register: 'Registra\'t',
      username: 'Nom d\'usuari',
      usernameOrEmail: 'Nom d\'usuari o Email',
      password: 'Contrasenya',
      email: 'Correu electrònic',
      name: 'Nom',
      description: 'Descripció',
      success: 'Èxit',
      warning: 'Advertència',
      info: 'Informació',
      home: 'Inici',
      settings: 'Configuració',
      profile: 'Perfil',
      summary: 'Resum',
      details: 'Detalls',
      view: 'Visualitza',
      update: 'Actualitza',
      help: 'Consells Útils',
      'Back to Dashboard': 'Tornar al Tauler',
      loadingTranslations: 'Carregant traduccions...',
      saveSelectedTags: 'Desar Etiquetes Seleccionades'
    },
    general: {
      close: 'Tancar',
      accept: 'Acceptar'
    },
    navbar: {
      home: 'Inici',
      menu: 'Menú',
      admin: 'Administració',
      login: 'Iniciar Sessió',
      logout: 'Tancar Sessió',
      settings: 'Configuració',
      createMenu: 'Crear Menú',
      dishLibrary: 'Biblioteca de Plats',
      translations: 'Traduccions',
      specialNames: 'Noms de Dies Especials',
      confirmNavigation: 'Sortir d\'aquesta pàgina?',
      unsavedChanges: 'Tens canvis sense desar. Si surts ara, els canvis es perdran. Si us plau, desa el teu treball abans de sortir o prem "Sortir" per descartar els canvis.',
      dashboard: 'Tauler',
      leave: 'Sortir',
      cancel: 'Cancel·lar',
      schoolHomepage: 'Pàgina Web de l\'Escola'
    },
    home: {
      welcome: 'Benvingut a l\'App de Menú Escolar',
      viewMenu: 'Veure Menú',
      aboutSchool: 'Sobre la Nostra Escola',
      contactUs: 'Contacta amb nosaltres'
    },
    login: 'Iniciar Sessió',
    loginPage: {
      email: 'Correu electrònic',
      password: 'Contrasenya',
      loginButton: 'Iniciar sessió',
      loginError: 'Correu electrònic o contrasenya invàlids',
      forgotPassword: 'Has oblidat la contrasenya?'
    },
    menu: {
      today: 'Menú d\'Avui',
      week: 'Menú Setmanal',
      noItems: 'No hi ha elements de menú disponibles',
      loading: 'Carregant menú...',
      download: 'Descarregar PDF',
      print: 'Imprimir Menú',
      dashboard: 'Tauler',
      leave: 'Sortir',
      favorites: 'Favorits',
      schoolHomepage: 'Pàgina Web de l\'Escola',
      title: 'Menú Escolar - {{month}}',
      menuType: 'Tipus de Menú',
      selectMenuType: 'Seleccionar tipus de menú',
      courses: 'Plats',
      day: 'Dia',
      firstCourse: 'Primer Plat',
      secondCourse: 'Segon Plat',
      dessert: 'Postres',
      dishNotTranslated: 'Plat encara no traduït',
      schoolLunchMenu: 'Menú Escolar',
      footer: 'El menú està subjecte a canvis segons la disponibilitat d\'ingredients',
      observations: 'Observacions',
      noMenu: 'No hi ha menú disponible per a aquest mes',
      noMenuTypes: 'Carregant tipus de menú...',
      loadingMenu: 'Carregant menú...',
      noMenuForType: 'Aquest tipus de menú no té un menú per al mes actual',
      noMenusAvailable: 'No hi ha menús disponibles per al mes actual',
      checkingAvailableMenus: 'Comprovant menús disponibles...',
      'There is no menu available for the current month.': 'No hi ha menú disponible per al mes actual.',
      createThisMenu: 'Crear aquest menú',
      editThisMenu: 'Editar aquest menú',
      notAvailable: 'No disponible',
      'Month/Year': 'Mes/Any',
      'Please select a menu type first': 'Si us plau, selecciona un tipus de menú primer',
      nutrientDataIncomplete: 'Informació nutricional no disponible',
      nutrientDataComplete: 'Informació nutricional completa',
      weekNumber: 'Setmana {{week}}',
      weekShort: 'Setmana',
      previousWeek: 'Setmana Anterior',
      nextWeek: 'Setmana Següent'
    },
    admin: {
      dashboard: 'Tauler de Control',
      users: 'Usuaris',
      dish: 'Plat',
      recentMenus: 'Menús Recents',
      month: 'Mes',
      actions: 'Accions',
      menus: 'Menús',
      dishes: 'Plats',
      settings: 'Configuració',
      translations: 'Traduccions',
      specialNames: 'Noms de Dies Especials',
      createDish: 'Crear Plat',
      editDish: 'Editar Plat',
      dishName: 'Nom del Plat',
      dishDescription: 'Descripció',
      dishType: 'Tipus de Plat',
      tags: 'Etiquetes',
      save: 'Desar',
      saveChanges: 'Desar Canvis',
      cancel: 'Cancel·lar',
      delete: 'Eliminar',
      confirmDelete: 'Estàs segur que vols eliminar aquest element?',
      menuType: 'Tipus de Menú',
      course: 'Plat',
      date: 'Data',
      dishesAvailable: 'Plats Disponibles',
      dishesSelected: 'Plats Seleccionats',
      addDish: 'Afegir Plat',
      removeDish: 'Eliminar',
      progress: 'Progrés',
      missingLanguages: 'Idiomes Faltants',
      noMissingTranslations: 'No Falten Traduccions',
      translationQueueDescription: 'Afegeix ràpidament traduccions faltants per a plats i noms de dies especials',
      specialNameEditor: 'Editor de Noms de Dies Especials',
      translationEditor: 'Editor de Traduccions',
      menuEditor: 'Editor de Menús',
      translationQueue: 'Cua de Traduccions',
      noTranslation: 'Sense traducció',
      noSpecialNames: 'No hi ha noms especials disponibles',
      editTranslations: 'Editar Traduccions',
      enterTranslation: 'Introduir Traducció',
      saveTranslations: 'Desar Traduccions',
      createSpecialName: 'Crear Nom Especial',
      dish: 'Plat',
      specialName: 'Nom de Dia Especial',
      allTranslationsComplete: 'Totes les traduccions estan completes!',
      itemsToTranslate: 'Elements per Traduir',
      translationsSaved: 'Traduccions desades!',
      translationsFullySaved: 'Totes les traduccions desades amb èxit!',
      translationsPartiallySaved: 'Traduccions desades per a: {{languages}}',
      skipItem: 'Saltar Element',
      selectItemToTranslate: 'Selecciona un element de la llista per traduir',
      noMoreItemsToTranslate: 'No hi ha més elements per traduir',
      noDishes: 'No hi ha plats disponibles',
      deleting: 'Eliminant...',
      loadingMenu: 'Carregant menú...',
      preparingMenuEditor: 'Preparant editor de menú',
      thisWillOnlyTakeAMoment: 'Això només trigarà un moment',
      addNewDish: 'Afegir Nou Plat',
      dishNamePlaceholder: 'Introdueix el nom del plat',
      menuUpdated: 'Menú actualitzat amb èxit!',
      menuCreated: 'Menú creat amb èxit!',
      editMenu: 'Editar Menú',
      createMenu: 'Crear Menú',
      recentMenus: 'Menús Recents',
      month: 'Mes',
      actions: 'Accions',
      edit: 'Editar',
      preview: 'Vista Prèvia',
      noMenusFound: 'No s\'han trobat menús. Crea el teu primer menú a l\'Editor de Menús.',
      menuEditorDesc: 'Crea i edita menús mensuals',
      translationEditorDesc: 'Gestiona traduccions per a plats i noms de dies especials',
      translationQueueDesc: 'Tradueix ràpidament elements que falten versions d\'idioma',
      settingsDesc: 'Configura usuaris i tipus de menú',
      menuDeleted: 'Menú eliminat amb èxit!',
      specialDayPlaceholder: 'Introdueix nom de dia especial',
      deleteMenu: 'Eliminar Menú',
      updateMenu: 'Actualitzar Menú',
      copy: 'Copiar',
      noCourses: 'No hi ha plats assignats',
      noCoursesHint: 'No s\'han assignat plats a aquest tipus de menú. Per afegir plats, vés a Tipus de Menú a l\'àrea d\'administració.',
      createNewSpecialName: 'Crear nou nom especial',
      createNewDish: 'Crear nou plat',
      noMatchingSpecialNames: 'No hi ha noms especials coincidents',
      noMatchingDishes: 'No hi ha plats coincidents',
      searchReplacement: 'Cercar substitut',
      general: {
        unknownDate: 'Data desconeguda'
      },
      // Translation editor specific items
      'Select a dish to translate': 'Selecciona un plat per traduir',
      'Edit Translations': 'Editar Traduccions',
      'Saving...': 'Desant...',
      'Save Translations': 'Desar Traduccions',
      'Add New Dish': 'Afegir Nou Plat',
      'Creating...': 'Creant...',
      'Create Dish': 'Crear Plat',
      nutrientQueue: 'Cua de Nutrients',
      nutrientQueueDesc: 'Afegeix ràpidament valors nutricionals faltants per als plats',
      tagQueue: 'Cua d\'Etiquetes',
      tagQueueDesc: 'Gestiona eficientment la informació d\'etiquetes per a múltiples plats',
      menuTypeVisibility: 'Visibilitat del Tipus de Menú',
      showMenuTypePublicly: 'Mostrar aquest tipus de menú al menú públic',
      visibilityExplanation: 'Quan està activat, aquest tipus de menú es mostrarà en el visualitzador de menú públic',
      menuTypeOptions: 'Opcions de Visualització',
      showNutrientsForMenuType: 'Mostrar informació nutricional per aquest tipus de menú',
      showTagsForMenuType: 'Mostrar informació d\'etiquetes per aquest tipus de menú',
      nutrientTagExplanation: 'Aquests ajustos controlen si la informació de nutrients i etiquetes es mostra per a aquest tipus de menú, a més de la configuració a nivell d\'escola.',
      menuTypeSaved: 'Tipus de menú desat correctament',
      menuTypeDeleted: 'Tipus de menú eliminat correctament',
      errorSavingMenuType: 'Error en desar el tipus de menú',
      errorDeletingMenuType: 'Error en eliminar el tipus de menú',
      menuTypeInUseExplanation: 'Heu de canviar el tipus de menú en aquests menús abans de poder eliminar-lo',
      noNutrients: 'Sense Nutrients',
      noTags: 'Sense Etiquetes',
      noTranslationAvailable: 'No hi ha traducció disponible',
      enterTranslation: 'Introduïu la traducció',
      requiredTranslation: 'Traducció obligatòria',
      defaultLanguageField: 'Camp de l\'idioma predeterminat',
      usingFallbackTranslation: 'Utilitzant traducció de reserva',
      translated: 'Traduït',
      noTranslation: 'Sense traducció',
      defaultMenuType: 'Tipus de Menú Predeterminat',
      defaultMenuTypeExplanation: 'El tipus de menú predeterminat s\'utilitzarà quan es creï un nou menú',
      selectDefaultMenuType: 'Seleccioneu el tipus de menú predeterminat',
      updateDefaultMenuType: 'Actualitzar Tipus de Menú Predeterminat',
      defaultMenuTypeUpdated: 'Tipus de menú predeterminat actualitzat',
      errorUpdatingDefaultMenuType: 'Error en actualitzar el tipus de menú predeterminat',
      noMenuTypesAvailable: 'No hi ha tipus de menú disponibles',
      manageMenuTypes: 'Gestionar Tipus de Menú',
      addNewMenuType: 'Afegir Nou Tipus de Menú',
      hidden: 'Ocult',
      coursesForMenuType: 'Tipus de plat per a aquest tipus de menú',
      loadingCourses: 'Carregant tipus de plat...',
      noCoursesForMenuType: 'No hi ha tipus de plat per a aquest tipus de menú',
      deleteMenuTypeConfirmation: 'Eliminar Tipus de Menú',
      confirmDeleteMenuType: 'Esteu segur que voleu eliminar el tipus de menú "{name}"?',
      cannotDeleteMenuTypeInUse: 'Aquest tipus de menú s\'utilitza en {count} menús i no es pot eliminar.',
      guidanceMenuCreation: {
        title: 'Benvingut a la Gestió de Menús!',
        description: 'Utilitza aquesta pàgina per crear menús mensuals. Després pots triar mostrar-los setmanalment o mensualment a la pàgina de configuració. Fes clic al botó crear a la part superior esquerra de la pantalla per crear el teu primer menú, i recorda desar-lo cada vegada que l\'actualitzis o es perdran els canvis, prement el botó de desar que apareixerà en aquest mateix lloc de la pantalla. Un cop tinguis un menú creat, pots previsualitzar-lo a la pàgina de previsualització i ajustar com es mostrarà a la teva comunitat a la pàgina de configuració. Feliç gestió de menús!'
      },
    },
    dishes: {
      add: 'Afegir Plat',
      edit: 'Editar Plat',
      name: 'Nom',
      description: 'Descripció',
      type: 'Tipus',
      tags: 'Etiquetes',
      search: 'Cercar Plats'
    },
    calendar: {
      monday: 'Dilluns',
      tuesday: 'Dimarts',
      wednesday: 'Dimecres',
      thursday: 'Dijous',
      friday: 'Divendres',
      saturday: 'Dissabte',
      sunday: 'Diumenge',
      january: 'Gener',
      february: 'Febrer',
      march: 'Març',
      april: 'Abril',
      may: 'Maig',
      june: 'Juny',
      july: 'Juliol',
      august: 'Agost',
      september: 'Setembre',
      october: 'Octubre',
      november: 'Novembre',
      december: 'Desembre'
    },
    general: {
      loading: 'Carregant...',
      save: 'Desar',
      saving: 'Desant...',
      cancel: 'Cancel·lar',
      edit: 'Editar',
      delete: 'Eliminar',
      create: 'Crear',
      search: 'Cercar',
      filter: 'Filtrar',
      noData: 'No hi ha dades disponibles',
      error: 'Error',
      retry: 'Tornar a provar',
      checkServerStatus: 'Comprovar estat del servidor',
      dish: 'Plat',
      specialName: 'Nom de Dia Especial'
    },
    modal: {
      cancel: 'Cancel·lar',
      delete: 'Eliminar',
      deletePrompt: 'Esteu segur que voleu eliminar {dish}?',
      confirmDelete: 'Confirmar Eliminació',
      changeUntranslatedSpecialName: 'Canviar nom especial sense traduir',
      changeUntranslatedDish: 'Canviar plat sense traduir',
      untranslatedSpecialName: 'Aquest nom especial encara no està traduït al català. Voleu canviar-lo per un altre? Acceptar eliminarà aquest nom especial d\'aquest dia.',
      untranslatedDish: 'Aquest plat encara no està traduït al català. Voleu canviar-lo per un altre? Acceptar eliminarà aquest plat d\'aquest dia.',
      dishInUse: 'Aquest plat s\'utilitza en {{count}} elements del menú.',
      specialNameInUse: 'Aquest nom especial s\'utilitza en {{count}} dies.',
      selectReplacementDish: 'Seleccioneu un plat de reemplaçament per utilitzar en tots els menús afectats.',
      selectReplacementSpecialName: 'Seleccioneu un nom especial de reemplaçament per utilitzar en tots els dies afectats.',
      replacementRequired: 'Cal un reemplaçament per eliminar aquest element.',
      confirmDeleteDish: 'Esteu segur que voleu eliminar aquest plat? Aquesta acció no es pot desfer.',
      confirmDeleteSpecialName: 'Esteu segur que voleu eliminar aquest nom especial? Aquesta acció no es pot desfer.',
      deleteAndReplace: 'Eliminar i Reemplaçar',
      deletePermanently: 'Eliminar Permanentment',
      validReplacementSelected: 'Reemplaçament vàlid seleccionat',
      confirmDeleteMenu: 'Confirmar Eliminació de Menú',
      deleteMenuWarning: 'Esteu segur que voleu eliminar aquest menú?',
      actionCannotBeUndone: 'Aquesta acció no es pot desfer.',
      allMenuDaysWillBeDeleted: 'Tots els dies d\'aquest menú seran eliminats.',
      allMenuItemsWillBeDeleted: 'Tots els elements del menú seran eliminats.',
      deleteMenu: 'Eliminar Menú'
    },
    languages: {
      en: 'Anglès',
      ca: 'Català',
      es: 'Espanyol',
      fr: 'Francès'
    },
    settings: {
      title: 'Configuració',
      manageUsers: 'Gestionar Usuaris',
      users: 'Usuaris',
      menuTypes: 'Tipus de Menú',
      courses: 'Tipus de Plat',
      nutrients: 'Nutrients',
      schoolInfo: 'Informació de l\'Escola',
      webhooks: 'Webhooks',
      addUser: 'Afegir Usuari',
      editUser: 'Editar Usuari',
      deleteUser: 'Eliminar Usuari',
      userName: 'Nom',
      userEmail: 'Correu Electrònic',
      userUsername: 'Nom d\'Usuari',
      userRoles: 'Rols',
      userRole: 'Rol',
      userPassword: 'Contrasenya',
      userSave: 'Desar Usuari',
      userUpdate: 'Actualitzar Usuari',
      userDelete: 'Eliminar Usuari',
      confirmDeleteUser: 'Esteu segur que voleu eliminar aquest usuari?',
      errorDeletingUser: 'Error al eliminar l\'usuari',
      userSaved: 'Usuari desat correctament',
      errorSavingUser: 'Error en desar l\'usuari',

      // User management
      roles: 'Rols',
      inviteUser: 'Convidar Usuari',
      invite: 'Convidar',
      inviting: 'Convidant...',
      emailRequired: 'El correu electrònic és obligatori',
      roleRequired: 'S\'ha de seleccionar almenys un rol',
      userNotExist: 'Aquest usuari no existeix. Ha de crear un compte primer',
      userInvited: 'Usuari convidat correctament a l\'escola',
      errorInvitingUser: 'Error en convidar l\'usuari',
      superadmin: 'Superadmin',
      admin: 'Administrador',
      editor: 'Editor',
      viewer: 'Visualitzador',
      userRolesUpdated: 'Rols d\'usuari actualitzats correctament',
      errorUpdatingRoles: 'Error en actualitzar els rols de l\'usuari',
      remove: 'Eliminar',
      userRemoved: 'Usuari eliminat de l\'escola correctament',
      errorRemovingUser: 'Error en eliminar l\'usuari de l\'escola',
      enterEmail: 'Introduïu adreça de correu electrònic',
      selectRoles: 'Seleccioneu Rols',
      updateRoles: 'Actualitzar Rols',
      superadminOnly: 'Només superadmin',
      cannotRemoveAdmin: 'Només els superadmins poden eliminar usuaris admin o superadmin',
      restrictedAccess: 'Accés restringit',
      noUsers: 'No s\'han trobat usuaris',
      errorFetchingUsers: 'Error en obtenir usuaris',
      roleExplanation: 'Permisos de Rols',
      superadminDesc: 'Accés complet a aquesta escola, pot assignar qualsevol rol incloent admin i superadmin',
      adminDesc: 'Accés complet a aquesta escola, no pot assignar admin/superadmin ni eliminar-los',
      editorDesc: 'Pot editar menús i contingut però no usuaris',
      viewerDesc: 'Accés de només lectura',

      schoolName: 'Nom de l\'Escola',
      subdomain: 'Subdomini',
      homepageUrl: 'URL de la Pàgina Principal',
      showNutrients: 'Mostrar Informació Nutricional',
      defaultLanguage: 'Idioma Predeterminat',
      saveBasicInfo: 'Desar Informació Bàsica',
      schoolInfoSaved: 'Informació de l\'escola desada correctament',
      errorSavingSchoolInfo: 'Error en desar informació de l\'escola',
      logo: 'Logo',
      uploadLogo: 'Pujar Logo',
      errorFetching: 'Error carregant configuració',
      subdomainLocked: 'Contacte amb suport tècnic per canviar el subdomini',
      schoolColors: 'Colors de l\'Escola',
      primaryBgColor: 'Color de Fons Primari',
      primaryTextColor: 'Color de Text Primari',
      secondaryBgColor: 'Color de Fons Secundari',
      secondaryTextColor: 'Color de Text Secundari',
      
      // Catalan subdomain-related translations
      checkingAvailability: 'Comprovant disponibilitat...',
      subdomainEmpty: 'El subdomini no pot estar buit',
      subdomainInvalidFormat: 'Format invàlid. Utilitzeu lletres minúscules, números i guions. No pot començar o acabar amb un guió.',
      subdomainCheckError: 'Error en comprovar la disponibilitat del subdomini',
      waitForSubdomainCheck: 'Si us plau, espereu mentre comprovem la disponibilitat del subdomini',
      subdomainNotAvailable: 'Aquest subdomini no està disponible',
      subdomainChanged: 'Subdomini actualitzat amb èxit! Els canvis de DNS poden trigar a propagar-se.',
      subdomainCooldown: 'Període de Refredament per a Canvi de Subdomini',
      cooldownWillEndOn: 'Podràs canviar el teu subdomini novament el {{date}} a les {{time}}.',
      subdomainChangeMessage: 'El teu subdomini s\'ha canviat en els darrers 14 dies. Pots canviar-lo de nou en 14 dies.',
      dnsNoteHeading: 'Nota important sobre canvis de subdomini:',
      dnsNote1: 'Pot trigar fins a 30 minuts perquè els canvis de DNS es propaguin per Internet.',
      dnsNote2: 'Durant aquest temps, alguns usuaris encara poden accedir al teu lloc a través del subdomini anterior.',
      dnsNote3: 'El teu subdomini anterior continuarà redirigint al teu nou subdomini durant 7 dies.',
      
      languages: 'Idiomes',
      manageLanguages: 'Gestionar Idiomes',
      availableLanguages: 'Idiomes disponibles',
      noLanguagesSelected: 'No s\'han seleccionat idiomes',
      languagesDescription: 'Seleccioneu quins idiomes voleu activar per a la vostra escola',
      menuTypesDescription: 'Els tipus de menú defineixen la estructura dels vostres menús',
      name: 'Nom',
      email: 'Correu electrònic',
      role: 'Rol',
      actions: 'Accions',
      edit: 'Editar',
      delete: 'Eliminar',
      add: 'Afegir',
      addNewUser: 'Afegir Nou Usuari',
      addNewMenuType: 'Afegir Nou Tipus de Menú',
      addNewCourse: 'Afegir Nou Tipus de Plat',
      saveChanges: 'Desar canvis',
      saveCustomContent: 'Desar Contingut Personalitzat',
      customContent: 'Descripció de l\'Escola',
      customContentPlaceholder: 'Introduïu una descripció de la vostra escola per mostrar a la pàgina principal',
      customContentSaved: 'Contingut personalitzat desat correctament',
      errorSavingCustomContent: 'Error en desar el contingut personalitzat',
      disclaimerText: 'Text de Descàrrec',
      disclaimerTextPlaceholder: 'Introduïu text de descàrrec per a les imatges del menú...',
      saveDisclaimerText: 'Desar Text de Descàrrec',
      disclaimerTextSaved: 'Text de descàrrec desat correctament',
      errorSavingDisclaimerText: 'Error en desar el text de descàrrec',
      includeCustomContentInImage: 'Incloure contingut personalitzat a les imatges del menú',
      includeCustomContentInImageExplanation: 'Controla si la descripció apareix en les imatges amb el menú diari descarregades des de la pàgina de previsualització de menús.',
      saveBranding: 'Desar Marca',
      saveDisplayOptions: 'Desar Opcions de Visualització',
      schoolInformation: 'Informació de l\'Escola',
      contactEmail: 'Correu electrònic de contacte',
      contactPhone: 'Telèfon de contacte',
      primaryColor: 'Color Primari',
      secondaryColor: 'Color Secundari',
      logoURL: 'URL del Logo',
      saving: 'Desant...',
      menuType: 'Tipus de Menú',
      course: 'Tipus de Plat',
      translations: 'Traduccions',
      defaultLanguageExplanation: 'Seleccioneu l\'idioma per defecte per a la vostra escola. Aquest idioma es mostrarà inicialment a tots els usuaris que no hagin seleccionat una preferència d\'idioma.',
      selectDefaultLanguage: 'Seleccionar Idioma per Defecte',
      noTranslationsAvailable: 'No hi ha traduccions disponibles',
      enterTranslation: 'Introduïu la traducció aquí...',
      cancel: 'Cancel·lar',
      save: 'Desa',
      nameRequired: 'Es requereix nom',
      atLeastOneTranslationRequired: 'Es requereix almenys una traducció',
      menuTypeSaved: 'Tipus de menú desat correctament',
      menuTypeDeleted: 'Tipus de menú eliminat correctament',
      courseSaved: 'Tipus de plat desat correctament',
      courseDeleted: 'Tipus de plat eliminat correctament',
      languagesSaved: 'Idiomes desats correctament',
      languageWarning: 'Nota: Deshabilitar un idioma l\'ocultarà de l\'intercanvi d\'idioma, però les traduccions existents es conservaran.',
      errorFetchingMenuTypes: 'Error carregant tipus de menú',
      errorFetchingCourses: 'Error carregant tipus de plat',
      errorFetchingSelectedLanguages: 'Error carregant idiomes seleccionats',
      errorSavingMenuType: 'Error en desar tipus de menú',
      errorSavingCourse: 'Error en desar tipus de plat',
      errorSavingLanguages: 'Error en desar idiomes',
      errorDeletingMenuType: 'Error eliminant tipus de menú',
      errorDeletingCourse: 'Error eliminant tipus de plat',
      errorFetchingTranslations: 'Error en obtenir les traduccions.',
      errorUpdatingMenuType: 'Error en actualitzar el tipus de menú.',
      errorUpdatingCourse: 'Error en actualitzar tipus de plat',
      usingFallbackTranslation: 'Utilitzant traducció de reserva',
      deleteMenuTypeConfirmation: 'Eliminar Tipus de Menú',
      deleteCourseConfirmation: 'Eliminar Tipus de Plat',
      confirmDeleteMenuType: 'Esteu segur que voleu eliminar el tipus de menú "{name}"?',
      confirmDeleteCourse: 'Esteu segur que voleu eliminar el tipus de plat "{name}"?',
      cannotDeleteMenuTypeInUse: 'Aquest tipus de menú s\'utilitza en {count} menús i no es pot eliminar.',
      cannotDeleteCourseInUse: 'Aquest tipus de plat s\'utilitza en {count} elements del menú i no es pot eliminar.',
      courseInUseExplanation: 'Heu d\'eliminar o substituir aquest tipus de plat en tots els menús abans de poder eliminar-lo.',
      usingFallbackTranslation: 'Utilitzant traducció de reserva',
    },
    upload: {
      fileTooLarge: 'El fitxer és massa gran. La mida màxima és {{maxSize}}MB.',
      invalidFileType: 'Tipus de fitxer no vàlid. Si us plau, puja un fitxer d\'imatge.',
      errorReadingFile: 'Error en llegir el fitxer. Si us plau, torna-ho a provar.',
      dragAndDrop: 'Arrossega i deixa anar el fitxer aquí',
      or: 'o',
      browse: 'navega pels fitxers',
      maxSizeNote: 'Mida màx. del fitxer: {{maxSize}}MB',
      acceptedFormatsNote: 'Formats acceptats'
    },
    preview: 'Previsualització',
    remove: 'Eliminar',
    languageNames: {
      en: 'Anglès',
      ca: 'Català',
      es: 'Espanyol',
      fr: 'Francès'
    },
    translations: {
      bulkTranslations: 'Traduccions en Bloc',
      individualTranslations: 'Traduccions Individuals',
      step1: 'Pas 1: Exportar Traduccions Pendents',
      step2: 'Pas 2: Completar Traduccions a Excel',
      uploadDescription: 'Puja el teu arxiu Excel completat amb traduccions.',
      step3: 'Pas 3: Validar i Importar',
      validateDescription: 'Verifica les teves traduccions i importa-les a la base de dades.',
      selectFile: 'Seleccionar Arxiu de Traducció',
      exportTranslations: 'Exportar Traduccions',
      exportPendingTranslations: 'Exportar traduccions pendents',
      exportAllTranslations: 'Exportar totes les traduccions',
      exporting: 'Exportant...',
      validating: 'Validant...',
      validateAndImport: 'Validar i Importar',
      confirmImport: 'Confirmar Importació',
      fileValid: 'Validació d\'Arxiu Exitosa',
      readyToImport: 'L\'arxiu de traduccions és vàlid i llest per ser importat.',
      validationResults: 'Resultats de Validació',
      importResults: 'Resultats d\'Importació',
      validationSummary: 'Resum de la validació de traduccions',
      importSummary: 'Resum de l\'operació d\'importació de traduccions',
      totalItems: 'Total d\'Elements',
      totalTranslations: 'Total de Traduccions',
      itemsProcessed: 'Elements Processats',
      translationsCreated: 'Traduccions Creades',
      translationsUpdated: 'Traduccions Actualitzades',
      warningsFound: 'Hi ha {{count, plural, one {# advertència} other {# advertències}}}',
      rowError: 'Fila {{row}}',
      moreErrors: 'i {{count}} errors més',
      importSuccess: 'Importació Exitosa',
      exportError: 'Error en exportar traduccions: {{error}}',
      importError: 'Error en importar traduccions: {{error}}',
      toBeCreated: 'Per Crear',
      toBeUpdated: 'Per Actualitzar',
      detailedChanges: 'Canvis Detallats',
      name: 'Nom',
      type: 'Tipus',
      language: 'Idioma',
      from: 'De',
      to: 'A',
      notSet: 'No establert',
      showingFirstN: 'Mostrant els primers {{count}} elements',
      newTranslationsHeading: 'Elements amb Noves Traduccions',
      updatedTranslationsHeading: 'Elements amb Traduccions Actualitzades',
      unchangedTranslationsHeading: 'Elements amb Traduccions Sense Canvis',
      item: 'Element',
      validationError: 'Error de Validació',
      validationErrorDetails: 'El fitxer pujat no s\'ha pogut validar a causa del problema següent:',
      fileEmpty: 'El fitxer sembla estar buit o té un format no vàlid.',
      requiredColumnsNotFound: 'No s\'han trobat les columnes requerides (ID, Tipus, Nom de Referència) al fitxer.',
      noLanguageColumns: 'No s\'han trobat columnes d\'idioma vàlides al fitxer.',
      wrongFileFormat: 'El fitxer podria estar en un format incorrecte. Si us plau, utilitzeu la plantilla del pas "Exportar Traduccions".',
      fileStructureExample: 'El fitxer ha de tenir primer les columnes d\'idioma (com "Anglès", "Espanyol", "Català"), seguides de les columnes "ID", "Tipus" i "Nom de Referència".',
      tryExportFirst: 'Intenta exportar primer un fitxer de plantilla, després afegeix les teves traduccions en comptes de crear un fitxer des de zero.',
    },
    fileUploader: {
      dragDrop: 'Arrossega i deixa anar el teu arxiu aquí',
      or: 'o',
      browse: 'cerca arxius',
      acceptedTypes: 'Arxius acceptats',
      maxSize: 'Mida màxima',
      fileSelected: 'Arxiu seleccionat. Fes clic per reemplaçar.',
      clear: 'Esborrar',
      invalidType: 'Tipus d\'arxiu no vàlid. Si us plau, selecciona un de: {{acceptedTypes}}',
      fileTooLarge: 'L\'arxiu és massa gran. La mida màxima és {{maxSize}} MB',
      clickToReplace: 'Clic o arrossega per reemplaçar',
      currentFile: 'Fitxer actual', 
      fileError: 'Hi ha hagut un error amb el fitxer'
    },
    // Translation Queue
    translationQueue: 'Cua de Traducció',
    translationQueueDescription: 'Afegeix ràpidament traduccions que falten per a plats i noms de dies especials',
    itemsToTranslate: 'Elements per Traduir',
    progress: 'Progrés',
    missingLanguages: 'Idiomes que Falten',
    enterTranslation: 'Introdueix la traducció',
    saveTranslations: 'Desar Traduccions',
    translationsSaved: 'Traduccions desades amb èxit!',
    translationsFullySaved: 'Totes les traduccions desades amb èxit!',
    translationsPartiallySaved: 'Traduccions desades per a: {{languages}}',
    skipItem: 'Saltar Element',
    selectItemToTranslate: 'Selecciona un element de la llista per traduir',
    noMoreItemsToTranslate: 'No hi ha més elements per traduir',
    noMissingTranslations: 'No falten traduccions',
    allTranslationsComplete: 'Totes les traduccions estan completes! Bon treball!',
    
    // Pagination specific translations
    pagination: {
      showing: 'Mostrant',
      to: 'a',
      of: 'de',
      results: 'resultats',
      previous: 'Anterior',
      next: 'Següent'
    },
    
    // Nutrient Tab Specific (Catalan)
    nutrientutils: {
      nutrients: 'Nutrients',
      nutrientDisplaySettings: 'Configuració de Visualització de Nutrients',
      nutritionalInformationExplanation: 'Trieu si la informació nutricional de cada menú diari s\'ha de mostrar al visualitzador de menús. Si a algun plat del menú diari li falta informació nutricional, es mostrarà un missatge indicant que la informació nutricional no està disponible.',
      showNutrients: 'Mostrar informació nutricional al visualitzador de menús',
      addNewNutrient: 'Afegir Nou Nutrient',
      errorLoadingNutrients: 'Error en carregar els nutrients. Si us plau, torneu a intentar-ho més tard.',
      noNutrientsYet: 'Encara no s\'han creat nutrients.',
      disabled: 'Amagat',
      enabledNutrient: 'Mostrar aquest nutrient al visualitzador de menús',
      editNutrient: 'Editar Nutrient',
      deleteNutrient: 'Eliminar Nutrient',
      deleteNutrientConfirmation: 'Esteu segur que voleu eliminar aquest nutrient? Aquesta acció no es pot desfer.',
      nutrientUpdated: 'Nutrient actualitzat correctament',
      errorUpdatingNutrient: 'Error en actualitzar el nutrient.',
      nutrientDeleted: 'Nutrient eliminat correctament',
      errorDeletingNutrient: 'Error en eliminar el nutrient.',
      errorCreatingNutrient: 'Error en crear el nutrient. Si us plau, torneu a intentar-ho.',
      bulkNutrientsTitle: 'Operacions Massives de Nutrients',
      step1: 'Pas 1: Exportar Plantilla',
      exportDescription: 'Descarregueu un fitxer Excel que conté plats i nutrients activats. Podeu exportar només plats amb nutrients faltants o tots els plats.',
      exportMissingButton: 'Exportar Faltants',
      exportAllButton: 'Exportar Tots',
      exportError: 'Error en exportar dades de nutrients: {{error}}',
      step2: 'Pas 2: Pujar Fitxer Completat',
      importDescription: 'Empleneu els valors nutricionals al fitxer Excel exportat i pugeu-lo aquí.',
      selectFileButton: 'Seleccionar Fitxer de Nutrients (.xlsx)',
      validationError: 'Error de Validació del Fitxer',
      validationErrorDetails: 'El fitxer pujat no s\'ha pogut validar a causa del problema següent:',
      wrongFileFormat: 'El fitxer pot tenir un format o estructura incorrecte. Si us plau, utilitzeu la plantilla del pas "Exportar".',
      fileStructureExample: 'El fitxer ha de tenir les columnes "ID Plat", "Nom de Referència", seguides de columnes per a cada nutrient activat (p. ex., "Energia (kcal)", "Proteïna (g)").',
      tryExportFirst: 'Intenteu exportar primer un fitxer de plantilla i després afegiu-hi els vostres valors nutricionals.',
      checkUnits: 'Assegureu-vos que els valors nutricionals coincideixin amb les unitats esperades (si s\'especifiquen a la capçalera).',
      step3: 'Pas 3: Validar i Importar',
      validateDescription: 'Comproveu si hi ha errors al fitxer pujat abans d\'importar les dades.',
      validateImportButton: 'Validar Fitxer',
      itemType: 'Plats',
      confirmImportButton: 'Importar Nutrients',
      importSuccessMessage: 'Importació de nutrients correcta',
      validationModalTitle: 'Validació d\'Importació de Nutrients',
      fileEmpty: 'El fitxer sembla estar buit o té un format no vàlid.',
      missingNutrientColumns: 'Falten columnes de nutrients requerides: {{message}}',
      invalidNumericValue: 'S\'ha trobat un valor numèric no vàlid. Els valors han de ser números no negatius.',
      invalidDishId: 'ID de plat no vàlid trobat: {{message}}',
      importResults: 'Resultats d\'Importació',
      importSummary: 'Resum de l\'operació d\'importació de nutrients',
      validationFailedSummary: 'El fitxer conté errors i no es pot importar.',
      validationSuccessSummary: 'Reviseu els canvis a continuació abans de confirmar la importació.',
      fileName: 'Nom del Fitxer',
      dishesToUpdate: 'Plats per Actualitzar',
      totalValuesToUpdate: 'Total de Valors per Actualitzar',
      errorsFound: '{{count}} Error(s) Trobat(s)',
      rowError: 'Fila {{row}}',
      updatedItemsHeading: 'Valors Nutricionals a Actualitzar',
      dishIdHeader: 'ID Plat',
      noValue: 'Sense Valor',
      fileValid: 'Fitxer Validat Correctament',
      readyToImport: 'El fitxer està llest per ser importat.',
      newValuesHeading: 'Plats amb Nous Valors Nutricionals ({{count}})',
      changedValuesHeading: 'Plats amb Valors Nutricionals Modificats ({{count}})',
      dishesWithUpdates: 'Plats Amb Actualitzacions',
      newValuesCount: 'Valors Nous',
      changedValuesCount: 'Valors Modificats',
    },
    queue: {
      individualInput: 'Entrada Individual',
      bulkImportExport: 'Importació/Exportació Massiva',
      dishesMissingNutrients: 'Plats amb Nutrients Faltants',
      missing: 'falten',
      editNutrientsFor: 'Editar Nutrients Per',
      missingNutrients: 'Nutrients Faltants',
      nutrientValuesSaved: 'Valors nutricionals desats correctament!',
      errorSavingNutrients: 'Error en desar els valors nutricionals',
      enterValue: 'Introduir valor',
      skipItem: 'Saltar Element',
      deleteDish: 'Eliminar Plat',
      saveAndNext: 'Desar i Següent',
      selectDishToEnterNutrients: 'Selecciona un plat de la llista per introduir valors nutricionals',
      nutrientQueueCompleteMessage: 'Tots els plats tenen els valors nutricionals introduïts.',
      nutrientQueueCompleteTitle: 'Cua de Nutrients Completa!',
      errorLoadingNutrientQueue: 'Error en carregar la cua de nutrients.',
    },
    // Month Navigation Settings
    monthNavigation: {
      title: 'Configuració de Navegació Pública',
      description: 'Permet als usuaris públics navegar entre períodes (mesos o setmanes) al visor de menús.',
      enable: 'Activar Navegació Pública',
      monthsBack: 'Períodes Enrere Permesos',
      monthsAhead: 'Períodes Endavant Permesos',
      daysAfterStart: 'Dies Permesos per Anar Enrere (Després d\'Inici de Període)',
      daysBeforeEnd: 'Dies Permesos per Anar Endavant (Abans de Final de Període)',
      saveSettings: 'Desar Configuració de Navegació',
      // Add new keys for the display type toggle
      displayType: 'Tipus de Visualització',
      weekly: 'Setmanal',
      monthly: 'Mensual',
      monthlyDescription: 'El menú públic mostrarà un mes complet a la vegada.',
      weeklyDescription: 'El menú públic mostrarà una setmana a la vegada.',
      // Adding Catalan versions of error messages previously missed
      invalidNumber: 'Si us plau, introduïu un número vàlid',
      mustBePositive: 'El valor ha de ser zero o positiu',
      tooManyMonths: 'El valor no pot excedir {{max}} períodes',
      tooManyDays: 'El valor no pot excedir {{max}} dies',
      maxMonthsRange: 'Màxim {{max}} períodes',
      maxDaysRange: 'Màxim {{max}} dies'
    },
    // Profile page translations (NEW SECTION)
    profilePage: {
      title: 'El Meu Perfil',
      name: 'Nom',
      username: 'Nom d\'usuari',
      email: 'Correu electrònic',
      nameRequired: 'El nom és obligatori',
      usernameRequired: 'El nom d\'usuari és obligatori',
      usernameInvalid: 'El nom d\'usuari només pot contenir lletres, números i guions baixos',
      usernameHint: 'Utilitza només lletres, números i guions baixos',
      emailRequired: 'El correu electrònic és obligatori',
      emailInvalid: 'El correu electrònic no és vàlid',
      emailInUse: 'El correu electrònic ja està en ús',
      usernameInUse: 'El nom d\'usuari ja està en ús',
      saveChanges: 'Desar Canvis',
      saving: 'Desant...',
      checking: 'Comprovant...',
      updateSuccess: 'Perfil actualitzat correctament',
      updateFailed: 'No s\'ha pogut actualitzar el perfil',
      changePassword: 'Canviar Contrasenya',
      changePasswordButton: 'Canviar Contrasenya',
      currentPassword: 'Contrasenya Actual',
      newPassword: 'Nova Contrasenya',
      confirmPassword: 'Confirmar Nova Contrasenya',
      currentPasswordRequired: 'La contrasenya actual és obligatòria',
      newPasswordRequired: 'La nova contrasenya és obligatòria',
      passwordTooShort: 'La contrasenya ha de tenir com a mínim 12 caràcters',
      passwordsDoNotMatch: 'Les contrasenyes no coincideixen',
      incorrectPassword: 'La contrasenya actual és incorrecta',
      passwordChangeSuccess: 'Contrasenya canviada correctament',
      passwordChangeFailed: 'No s\'ha pogut canviar la contrasenya',
      passwordRequirements: 'Mínim 12 caràcters',
      updatePassword: 'Actualitzar Contrasenya',
      changing: 'Canviant...',
      cancel: 'Cancel·lar'
    },
    // Errors (NEW SECTION)
    errors: {
      fetchNutrientDetailsFailed: 'Error en carregar els detalls del nutrient.',
    },
    // Excel Export Headers (NEW SECTION)
    excelHeaders: {
      referenceName: 'Nom de Referència'
    },
    // Add top-level login/school selector keys with proper translations
    loginToSchool: 'Iniciar sessió a {{schoolName}}',
    loginToAccount: 'Iniciar sessió al teu compte',
    mainDomainLoginDescription: 'Inicia sessió per accedir a totes les teves escoles',
    schoolSelectorTitle: 'Les teves Escoles',
    schoolSelectorDescription: 'Selecciona una escola per gestionar els seus menús i configuració',
    createNewSchool: 'Crear Nova Escola',
    accessAdmin: 'Accedir Admin',
    deleteSchool: 'Eliminar Escola',
    deleteSchoolConfirmation: 'Estàs segur que vols eliminar',
    deleteSchoolWarning: 'Aquesta acció no es pot desfer.',
    deleting: 'Eliminant...',
    creating: 'Creant...',
    createSchool: 'Crear Escola',
    schoolName: 'Nom de l\'Escola',
    subdomain: 'Subdomini',
    homepageUrl: 'URL del lloc web de l\'Escola',
    subdomainHelp: 'Només lletres minúscules, números i guions',
    noSchoolsFound: 'No tens accés a cap escola encara.',
    tags: {
      displaySettings: 'Configuració de visualització d\'etiquetes',
      showInMenu: 'Mostrar informació d\'etiquetes al menú públic',
      showInMenuHelp: 'Quan està habilitat, les icones d\'etiquetes apareixeran sota els plats al menú públic amb una llegenda que explica cada etiqueta.',
      existing: 'Etiquetes existents',
      createNew: 'Crear nova etiqueta',
      translations: 'Traduccions',
      logo: 'Logo de l\'etiqueta',
      uploadLogo: 'Pujar logo (opcional)',
      logoRequirements: 'Mida recomanada: 64x64px. Mida màxima: 2MB. Formats compatibles: JPG, PNG, GIF, SVG, WebP',
      create: 'Crear etiqueta',
      creating: 'Creant...',
      editTag: 'Editar etiqueta',
      deleteConfirmation: 'Eliminar etiqueta',
      deleteWarning: 'Estàs segur que vols eliminar aquesta etiqueta? Aquesta acció no es pot desfer.',
      noLogo: 'Sense logo',
      noTranslation: 'No hi ha traducció disponible',
      noLanguages: 'No hi ha idiomes seleccionats per a aquesta escola. Si us plau, afegeix idiomes a la pestanya d\'Idiomes.',
      defaultLanguageRequired: 'Es requereix traducció a l\'idioma predeterminat',
      translationRequired: 'Es requereix almenys una traducció',
      fetchError: 'Error en carregar les etiquetes',
      createSuccess: 'Etiqueta creada amb èxit',
      createError: 'Error en crear l\'etiqueta',
      updateSuccess: 'Etiqueta actualitzada amb èxit',
      updateError: 'Error en actualitzar l\'etiqueta',
      deleteSuccess: 'Etiqueta eliminada amb èxit',
      deleteError: 'Error en eliminar l\'etiqueta',
      settingUpdateSuccess: 'Configuració de visualització d\'etiquetes actualitzada',
      settingUpdateError: 'Error en actualitzar la configuració de visualització d\'etiquetes',
      noSchoolId: 'Falta l\'ID de l\'escola',
      loadError: 'Error en carregar les etiquetes',
      empty: 'Encara no s\'han creat etiquetes',
      fetchDetailError: 'Error en obtenir els detalls de l\'etiqueta',
      legend: 'Llegenda',
      noTagsInDish: 'Cap Etiqueta en aquest Plat',
      loading: 'Carregant etiquetes...',
      notConfiguredWarning: 'No hi ha etiquetes configurades. Afegiu etiquetes a la pàgina de Configuració primer.',
      queueTitle: 'Cua d\'Etiquetes',
      saved: 'Etiquetes desades correctament',
      saveError: 'Error en desar les etiquetes',
      selectAtLeastOneOrConfirmNone: 'Si us plau, seleccioneu almenys una etiqueta o utilitzeu el botó \'Confirmar: Sense Etiquetes\'.',
      dishes: 'Plats',
      noSearchResults: 'Cap plat coincideix amb la vostra cerca',
      noDishesNeedTags: 'Cap plat necessita informació d\'etiquetes',
      unsavedChanges: 'Canvis sense desar',
      pendingChanges: 'Pendent',
      assignFor: 'Assignar etiquetes per a',
      confirmNoTags: 'Confirmar: Sense Etiquetes',
      selectTags: 'Seleccionar etiquetes en aquest plat',
      noTagsConfigured: 'Encara no hi ha etiquetes configurades per a aquesta escola. Si us plau, afegiu etiquetes a la pàgina de Configuració primer.',
      selectDish: 'Seleccionar un plat per assignar etiquetes',
      allDishesComplete: 'Tots els plats tenen informació d\'etiquetes. Bona feina!'
    },
  },
};

export default ca;
